import { Box } from '@mui/material'
import { useIntl } from 'react-intl'

import { tokens } from '@configuration/theme'
import Button from '@base/Button/Button.component'
import { resolveBrandVisuals, type SsoBrand } from '@utils/oidc-providers.utils'
import { SSO_BRANDS } from '../../sso-brands.config'

interface Props {
  /** Fires with the clicked brand — provider resolution lives in useSsoRoute, not here. */
  onClick: (brand: SsoBrand) => void
  /** Disables every button, e.g. while /hrd/config hasn't resolved yet. */
  disabled?: boolean
}

// One button per enabled brand (SSO_BRANDS) — deliberately not driven by
// Kratos flow nodes. Which provider id ends up submitted is resolved
// separately, see useSsoRoute.
const PrimarySsoButtons = ({ onClick, disabled = false }: Props) => {
  const intl = useIntl()
  if (SSO_BRANDS.length === 0) {
    return null
  }
  return (
    <Box
      data-testid='primary-sso-buttons'
      sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}
    >
      {SSO_BRANDS.map((brand) => {
        const { label, icon } = resolveBrandVisuals(brand, intl)
        return (
          <Button
            key={brand}
            variant='bordered'
            size='lg'
            block={true}
            type='button'
            disabled={disabled}
            dataTestId={`primary-sso-${brand}`}
            onClick={() => onClick(brand)}
            sx={{ borderRadius: tokens.radiusMd }}
          >
            {icon}
            <Box component='span'>{label}</Box>
          </Button>
        )
      })}
    </Box>
  )
}

export default PrimarySsoButtons
